import React from 'react';
import { View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import ComponentRegistry from 'shared/renderer/ChildNodeRenderer/ComponentRenderer/ComponentRegistry';
import GroupRegistry from 'shared/renderer/ChildNodeRenderer/GroupRenderer/GroupRegistry';
import {
  isComponentId,
  isGroupId,
  isVXLReactNode,
  VXLComponent,
  VXLGroup,
  VXLReactNode,
} from 'shared/renderer/types';

export interface RendererProps {
  toRender: VXLComponent | VXLGroup | VXLReactNode;
}

const ChildNodeRenderer = ({ toRender }: RendererProps) => {
  if (!toRender) {
    return null;
  }

  if (isVXLReactNode(toRender)) {
    const { render } = toRender;
    return render();
  }

  const ComponentToRender = ComponentRegistry[toRender.name] as
    | null
    | ((props) => React.ReactNode);
  const GroupToRender = GroupRegistry[toRender.name] as
    | null
    | ((props) => React.ReactNode);

  if (isComponentId(toRender.name) && ComponentToRender) {
    return <ComponentToRender {...toRender.props} />;
  } else if (isGroupId(toRender.name) && GroupToRender) {
    return <GroupToRender {...toRender.props} />;
  }

  return (
    <View>
      <BodyBaseText>oops! something went wrong</BodyBaseText>
    </View>
  );
};

export default ChildNodeRenderer;
